export const flexCenter = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
